module.exports = __webpack_public_path__ + "assets/img/RaceType_Greyhounds-BLACK.aaade7ba.svg";